var _rect, _rect2, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultCpu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    fill: "none",
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    fill: "#2B2870",
    rx: 88
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_11269",
    width: 176,
    height: 176,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    fill: "#fff",
    rx: 88
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_11269)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_11269",
    width: 86,
    height: 101,
    x: 43,
    y: 40,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43 40.9529H128.647V140.47H43V40.9529Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_11269)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE413C",
    fillRule: "evenodd",
    d: "M76.1507 42.0825C57.3129 45.889 40.9767 65.12 43.204 90.7216C45.4313 116.324 65.5418 147.521 110.712 139.054C129.474 134.499 127.727 113.611 126.84 103.312C125.955 93.0141 133.738 74.9732 122.497 57.6679C111.257 40.3636 89.4179 39.4012 76.1507 42.0825Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M59.4447 85.6129C49.8175 90.5057 49.9006 111.173 61.9029 117.886C73.9062 124.6 91.3207 120.766 94.1838 115.427C98.5012 107.374 88.3986 92.5848 78.526 87.3118C70.1686 82.8488 64.3196 83.1346 59.4447 85.6129Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M65.0984 91.4784C57.8589 95.1582 57.8512 109.051 66.8773 114.1C75.9044 119.149 87.5357 116.412 89.619 112.361C92.056 107.623 86.8728 96.7218 79.4478 92.7561C73.163 89.3993 68.7645 89.6156 65.0984 91.4784Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M126.841 103.312C126.253 96.4759 129.479 86.2282 128.431 75.0496C126.349 71.4841 122.757 70.0634 117.111 73.0115C111.084 76.1587 100.501 89.04 106.293 105.06C108.411 110.92 119.586 112.92 125.772 106.362C126.183 105.927 126.579 105.365 126.959 104.708C126.919 104.227 126.88 103.756 126.841 103.312Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M115.744 78.9757C111.223 81.3368 104.688 90.403 109.032 102.42C110.622 106.815 117.6 108.913 122.24 103.993C127.046 98.8994 129.436 71.8256 115.744 78.9757Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M85.171 111.839C82.6335 106.383 74.8229 103.055 69.7857 107.49C69.3286 107.891 69.661 108.829 70.3345 108.634C72.9329 107.886 75.4481 107.064 78.1692 107.709C80.8217 108.338 83.0132 110.048 84.5477 112.235C84.7941 112.586 85.343 112.209 85.171 111.839Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M113.359 102.98C114.181 97.955 117.123 94.6591 120.686 91.2309C121.113 90.8183 120.687 90.0846 120.106 90.3428C115.27 92.4915 112.749 97.9293 112.283 102.889C112.218 103.579 113.249 103.649 113.359 102.98Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M112.739 81.7207C110.914 81.8732 109.387 83.795 108.387 85.1347C107.057 86.9156 105.848 88.988 106.896 91.1661C107.216 91.8341 108.076 92.3257 108.834 92.1409C111.203 91.5606 112.076 89.5463 112.786 87.4168C113.318 85.8236 114.097 83.6045 113.28 81.9932C113.173 81.7817 112.966 81.7017 112.739 81.7207Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M75.4279 96.1188C76.1652 97.7424 78.3896 98.5733 79.9666 99.1679C82.1156 99.9778 84.226 100.61 86.2059 99.1517C86.835 98.6877 86.9925 97.7253 86.6678 97.0507C85.6203 94.8697 83.3003 94.4962 81.0517 94.3742C79.3491 94.2827 76.8396 94.2303 75.5564 95.5328C75.397 95.6948 75.3303 95.9044 75.4279 96.1188Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M111.686 111.162C112.09 110.052 102.758 95.1051 99.5745 96.299C96.9684 97.2785 94.9344 116.269 96.293 116.502",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M104.752 117.213C98.4092 119.144 87.8041 122.368 90.4614 129.973C92.7496 136.519 104.732 134.023 109.066 131.539C112.976 129.3 122.387 126.535 121.296 118.606C120.204 110.678 107.981 116.231 104.752 117.213Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M104.972 118.858C100.129 120.332 92.0322 122.794 94.0604 128.601C95.8075 133.599 104.956 131.693 108.266 129.796C111.252 128.086 118.436 125.975 117.603 119.921C116.77 113.867 107.438 118.107 104.972 118.858Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3DFA2",
    fillRule: "evenodd",
    d: "M100.481 98.5419C98.6004 99.247 97.1335 112.948 98.1134 113.115C99.0932 113.282 108.926 110.063 109.218 109.263C109.509 108.463 102.777 97.6805 100.481 98.5419Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.851 122.215C104.053 122.721 97.7831 121.852 96.613 123.896C95.4428 125.939 96.0583 130.482 107.67 127.188C119.282 123.893 116.452 118.891 114.153 118.532C111.854 118.173 105.851 122.215 105.851 122.215Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M102.086 122.439C102.353 124.343 102.666 126.317 103.205 128.167C103.65 128.104 104.117 128.027 104.614 127.93C104.206 126.089 103.701 124.261 103.288 122.415C102.902 122.421 102.498 122.428 102.086 122.439Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B122E",
    fillRule: "evenodd",
    d: "M109.048 120.289C109.76 122.172 110.467 124.111 111.398 125.875C111.814 125.691 112.191 125.505 112.545 125.318C111.941 123.405 111.038 121.534 110.211 119.689C109.816 119.882 109.426 120.084 109.048 120.289Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M96.8406 77.7529C96.8976 77.7529 96.8976 77.6662 96.8406 77.6662C96.7836 77.6662 96.7836 77.7529 96.8406 77.7529Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M61.9507 71.507C60.5631 70.4217 58.2875 70.6018 56.981 71.7185C54.919 73.4822 54.747 76.5722 56.5211 78.6132C57.6613 79.9253 59.2412 81.0677 61.0646 80.2311C62.171 79.7252 63.1382 78.3902 63.5866 77.2764C64.4601 75.1087 63.7692 72.9296 61.9507 71.507Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M47.0551 79.1405C44.8104 79.6541 43.1426 81.7532 43.6102 84.0886C44.2238 87.15 47.2696 88.7975 50.2661 88.2162C52.9562 87.6931 54.1225 84.9814 53.1717 82.5955C52.2373 80.2525 49.6496 78.5469 47.0551 79.1405Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M46.6233 99.1763C47.638 99.0877 48.3743 98.6046 49.1222 97.9691C50.3977 96.8848 49.8421 95.2154 48.5134 94.5332C48.6709 94.6123 48.639 94.5913 48.4178 94.4703C48.1598 94.3093 47.8911 94.1645 47.6138 94.0368C47.0659 93.8367 46.1962 93.7662 45.6232 93.8719C44.8821 94.0072 44.197 94.4808 43.7573 95.1068C43.9477 96.2731 44.1757 97.445 44.4405 98.6199C45.0589 99.042 45.8445 99.244 46.6233 99.1763Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M118.962 58.6484C116.356 60.6255 117.045 64.3206 119.437 66.1005C120.328 66.7637 121.716 66.8923 122.708 66.3759C123.996 65.7051 125.008 64.4388 125.398 63.0581C124.669 61.3926 123.792 59.7251 122.74 58.0634C121.517 57.6031 120.173 57.7308 118.962 58.6484Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M76.4503 59.7586C80.0575 62.1426 81.9591 65.6052 82.4491 69.8424C82.7902 72.7857 82.0625 76.7704 83.3661 79.5003C84.3159 81.4908 86.7549 82.3397 88.1357 80.2807C88.1608 80.2444 88.1212 80.1997 88.0806 80.2159C85.1112 81.4536 85.8272 72.2454 85.8089 71.1802C85.7702 68.962 85.5885 66.7428 84.8638 64.6276C83.6096 60.9687 80.9069 57.9177 77.6186 55.8682C74.0249 53.6281 69.7327 52.5762 65.5264 52.2751C62.9367 52.0883 59.9857 52.2998 57.2511 52.0369C55.9098 53.2917 54.6382 54.6457 53.4458 56.0921C53.9106 56.236 54.3821 56.3627 54.8576 56.459C62.2371 57.952 69.638 55.2565 76.4503 59.7586Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M90.5288 54.5851C89.8998 58.4917 90.4737 62.5775 92.5426 65.9934C93.5408 67.6427 94.8539 69.0119 96.2725 70.3116C97.4794 71.4188 105.003 76.4888 102.085 78.3697C102.052 78.3906 102.073 78.4459 102.11 78.4469C105.257 78.5469 105.614 75.5322 104.069 73.3664C102.318 70.9109 99.5559 69.2311 97.5731 66.9643C94.5901 63.556 93.5678 59.6008 94.4897 55.1902C95.5854 49.9468 98.9916 46.5909 102.175 42.9482C100.408 42.4289 98.6235 42.0173 96.8397 41.7124C96.7972 41.7639 96.7527 41.8163 96.7112 41.8677C93.7263 45.5647 91.2893 49.8658 90.5288 54.5851Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M76.9728 49.7214C77.0356 49.7023 77.0704 49.5918 76.9854 49.5728C74.5677 49.0334 72.2274 48.4551 70.1121 47.1164C69.1565 46.5113 68.3245 45.7481 67.479 45.0049C66.6229 45.4146 65.7812 45.8653 64.9512 46.3408C66.2731 47.1383 67.4152 48.1788 68.8357 48.902C71.3355 50.1749 74.2817 50.5237 76.9728 49.7214Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M86.2469 46.6543C86.2179 46.6876 86.2643 46.7305 86.2991 46.7153C89.0665 45.5461 89.9072 43.5461 90.7479 41.0383C89.8212 40.9887 88.9042 40.964 87.9949 40.9583C88.1244 42.9211 87.8471 44.8315 86.2469 46.6543Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M100.47 62.4184C100.51 62.4803 100.625 62.4793 100.628 62.3898C100.741 58.8071 100.367 55.5608 101.836 52.144C103.095 49.2131 105.34 46.9987 107.822 45.054C107.178 44.7567 106.527 44.4832 105.871 44.2222C100.227 48.0059 96.6709 56.3755 100.47 62.4184Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD91D",
    fillRule: "evenodd",
    d: "M51.0046 65.4401C57.0845 65.8413 68.3718 61.1495 72.3896 66.917C72.7935 67.4963 73.7376 66.8722 73.4284 66.2577C71.576 62.5835 67.937 61.7536 64.0418 61.4764C60.396 61.2172 54.5789 61.7708 50.2036 60.5664C49.3223 61.9594 48.5029 63.4106 47.7637 64.9247C48.7715 65.2086 49.8818 65.3658 51.0046 65.4401Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE413C",
    fillRule: "evenodd",
    d: "M76.1504 42.0819C62.6513 44.8098 50.4403 55.4596 45.4204 70.6973C46.1538 69.6987 46.9385 68.7354 47.7501 67.8111C55.6399 58.8326 66.4199 52.361 78.1304 49.5711C89.8418 46.7812 102.429 47.6855 113.606 52.1218C116.29 53.1871 118.903 54.4772 121.347 56.0084C109.821 40.3058 88.9789 39.4902 76.1504 42.0819Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M60.1992 127.052C71.1512 137.368 87.6699 143.373 110.712 139.054C122.335 136.232 126.084 127.142 127.045 118.183C119.693 129.399 114.024 132.823 98.8925 134.151C80.6402 135.755 72.4132 130.972 60.1992 127.052Z",
    clipRule: "evenodd",
    opacity: 0.01
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultCpu);
export default __webpack_public_path__ + "static/media/result_cpu.9f03ad0ec34ec144ea7c5665fc06332f.svg";
export { ForwardRef as ReactComponent };